var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "name": "V-Verify",
      "navConfig": _vm.navConfig
    }
  }, [_c('router-view'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/joinyi/v-verify",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "github-icon"
  })])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6677980b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-6677980b","hasScoped":false}!./node_modules/.13.0.4@vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = 233
// module chunks = 5